import { GenericType } from "./props";

const EmployeeLeaveTypes: GenericType[] = [
    {key: "annual leave", text: "Cuti tahunan"},
    {key: "sick leave", text: "Sakit"},
    {key: "maternity leave", text: "Melahirkan"},
    {key: "others", text: "Lain-lain"}
]

export default EmployeeLeaveTypes;